import { useSdk } from '~/sdk';


export const useProductFeatures = () => {
  const {locale} = useI18n();

  const productInfo = useAsyncData(`product-${locale.value}`, async () =>
    await useSdk().cms.getContent({
      globalSet: {
        handle: 'product',
        fragment: ` 
        ... on product_GlobalSet {
          title
          features {
            title
            ... on feature_Entry {
              title
              body
              image {
                title
                alt
                url
              }
              callToAction3 {
                title
                target
                url
                label 
              } 
            }
          }
        }
      `,
      },
    }),
  );


  return {
    
    features: computed(() => productInfo.data.value?.features ?? []),
  };
};
